import { Component } from "@angular/core";

@Component({
    selector: 'ngx-popover-help-pasword',
    template: `
      <div class="p-4">
            La Contraseña Debe contener: 
            <ul> 
                <li>Mínimo 8 caracteres y máximo 16 caracteres</li>
                <li>Al menos una letra mayúscula y una minúscula</li>
                <li>Al menos un número</li> 
                <li>Al menos un caracter especial: *#!_-@.,$%&+?</li>
            </ul>
            La Contraseña No debe contener: 
            <ul>
                <li>3 caracteres iguales consecutivos</li>
                <li>Tu nombre de usuario</li>
                <li>Tu documento de identificación</li>
                <li>Tus nombres o apellidos</li>
                <li>Espacios en blanco</li>
            </ul>
      </div>
    `,
})
export class PopoverHelpPasswordComponent {
}